import {Constructor} from "../../global/constructor";
import ObjectModelBuilderModel from "../models/tracked/objectModelBuilderModel";
import {Hash} from "../interfaces/hashInterfaces";
import ObjectModelActionPermission from "~/models/objectModelPermissions/objectModelActionPermission";
import ObjectModelPropertyPermission from "~/models/objectModelPermissions/objectModelPropertyPermission";
import {ObjectHelper} from "../helpers/objectHelper";
import {IObjectModelPermissionContainer} from '~/interfaces/objectModelInterfaces'

export type ObjectModelPermissionTypes = ObjectModelActionPermission | ObjectModelPropertyPermission;

export default function ObjectModelPermissionContainer<TBase extends Constructor<ObjectModelBuilderModel>>(Base: TBase) {
  return class ObjectModelContainer extends Base implements IObjectModelPermissionContainer {
    permissions: Hash<ObjectModelPermissionTypes> = {};
    current_user_permissions?: Hash<ObjectModelPermissionTypes> = {};

    get permissionsArray(): ObjectModelPermissionTypes[] {
      return ObjectHelper.toArray(this.permissions);
    }

    get hasPermissions(): boolean {
      return Object.keys(this.permissions).length > 0;
    }

    get currentUserPermissionsArray(): ObjectModelPermissionTypes[] {
      if (!this.current_user_permissions) return []
      return ObjectHelper.toArray(this.current_user_permissions);
    }
  };
}